import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';
import {pxToVW} from '../../utils/pxToVW';

export default class Text extends Component {
  getClass = (size) => {
    let textClass = 'default-text';
    switch (size) {
      case 'huge':
        textClass = 'huge-text';
        break;
      case 'big':
        textClass = 'big-text';
        break;
      case 'large':
        textClass = 'large-text';
        break;
      case 'small':
        textClass = 'small-text';
        break;
      default:
        break;
    }
    return textClass;
  }
  render() {
    const { text, size = 'default',textAlign, fontSize, fontWeight, lineHeight, style, href, target, cid, vid, nativePage, event = 'doNothing', ...restProps} = this.props;
    const newFontSize = fontSize && pxToVW({fontSize});
    let textStyle = _.omitBy(Object.assign({},{textAlign, fontWeight, lineHeight},newFontSize, style), _.isUndefined);
    const textClass = this.getClass(size);
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target))? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openNativeView') {
      params =  { nativePage }
    }
    const clickEvent = event !== undefined && function () { CrgtEvent[`${event}`](params) };
    // return React.createElement('div', { 'className': textClass, style: style }, text);
    return (<div {...restProps} className={textClass} style={textStyle}  onClick={clickEvent}>{text}</div>)
  }
}